<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container px-5">
      <router-link v-if="!isAuth" class="navbar-brand" to="/" >JIR</router-link>
      <router-link v-else class="navbar-brand" to="/dashboard" >JIR</router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <template v-if="!isAuth">
            <li class="nav-item"><router-link class="nav-link" to="/login">Iniciar sesión</router-link></li>
          </template>
          <template v-else>
            <li class="nav-item"><router-link class="nav-link" to="/dashboard" v-if="$localStorageService.can('api.DASHBOARD')" >Dashboard</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/tier" v-if="$localStorageService.can('api.REPORTE_TIER')" >TIER</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/registrarEvento" v-if="$localStorageService.can('api.REGISTRO_ASISTENCIA')">Registrar evento</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/registrarEvidencia" v-if="$localStorageService.can('api.REGISTRO_EVIDENCIA')">Registrar evidencia</router-link></li>
            <li class="nav-item dropdown" v-if="$localStorageService.can('api.ADM_PERMISOS')
                                                        || $localStorageService.can('api.ADM_PERFILES')
                                                        || $localStorageService.can('api.ADM_CARGA_MASIVA')
                                                        || $localStorageService.can('api.ADM_CLIENTES')
                                                        || $localStorageService.can('api.ADM_SUCURSALES')
                                                        || $localStorageService.can('api.ADM_AREAS_SUCURSAL')
                                                        || $localStorageService.can('api.ADM_EMPLEADOS')
                                                ">
              <a class="nav-link dropdown-toggle" id="navbarDropdownBlog" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Administración
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownBlog">
                <li><router-link class="dropdown-item" to="/adminPermisos" v-if="$localStorageService.can('api.ADM_PERMISOS')">Permisos</router-link></li>
                <li><router-link class="dropdown-item" to="/adminPerfiles" v-if="$localStorageService.can('api.ADM_PERFILES')">Perfiles</router-link></li>
                <li><router-link class="dropdown-item" to="/cargaMasiva" v-if="$localStorageService.can('api.ADM_CARGA_MASIVA')" >Carga masiva empleados</router-link></li>
                <li><router-link class="dropdown-item" to="/clientes" v-if="$localStorageService.can('api.ADM_CLIENTES')">Clientes</router-link></li>
                <li><router-link class="dropdown-item" to="/sucursales" v-if="$localStorageService.can('api.ADM_SUCURSALES')">Sucursales</router-link></li>
                <li><router-link class="dropdown-item" to="/areas_sucursal" v-if="$localStorageService.can('api.ADM_AREAS_SUCURSAL')">Áreas de Sucursal</router-link></li>
                <li><router-link class="dropdown-item" to="/empleados" v-if="$localStorageService.can('api.ADM_EMPLEADOS')">Empleados</router-link></li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarDropdownBlog" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{nombreUsuario}}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownBlog">
<!--                <li><router-link class="dropdown-item" to="/historial">Historial de eventos</router-link></li>-->
<!--                <li><a class="dropdown-item" href="blog-home.html">Cambiar contraseña</a></li>-->
                <li><a class="dropdown-item" href="#" @click="cerrarSesion()">Cerrar sesión</a></li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  inject: ['$localStorageService'],
  name: 'Header-Component',
  components: {

  },
  data() {
    return {
      isAuth: false
    }
  },
  computed: {
    nombreUsuario() {
      return this.$localStorageService.getNombreCompleto();
    }
  },
  watch:{
    $route (){
      this.isAuth = this.$localStorageService.isAuth();
    }
  },
  created() {
  },
  async mounted() {
  },
  methods: {
    cerrarSesion() {
      this.$localStorageService.destroy();
      this.$router.push({ name: 'login' }).then(() => {
        this.$router.go(0);
      });

    }
  },
  filters: {

  }
};
</script>

<style scoped>

</style>
